module.exports = __webpack_public_path__ + "180d70a6ab20ee4b7339ffa1399849b1.svg";